import Accordion from "@/common/components/Accordion";
import ResumeBox from "@/common/components/ResumeBox";
import useNegotiationEquipmentCategorySummary from "../hooks/useNegotiationEquipmentCategorySummary";
import EquipmentQuantityNote from "./EquipmentQuantityNote";

const EquipmentCategorySummary = () => {
  const { data: equipmentCategoriesSummary, isPending: equipmentCategoriesSummaryIsPending } = useNegotiationEquipmentCategorySummary();

  const equipmentsCountSum = equipmentCategoriesSummary?.reduce((sum, { count }) => sum + count, 0);

  if (!equipmentCategoriesSummary?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <EquipmentQuantityNote />

      <Accordion
        head="Detalhes da frota"
        triggerDisabled={equipmentCategoriesSummaryIsPending}
        body={(
          <div className="flex flex-col gap-2">
            <ResumeBox
              label="Total de equipamentos"
              value={equipmentsCountSum}
            />

            <div className="grid grid-cols-2 gap-2">
              {equipmentCategoriesSummary?.map(({ name, count }, index) => {
                const expandColumn = (Number(equipmentCategoriesSummary?.length) % 2) && Number(equipmentCategoriesSummary?.length) === index + 1;

                return (
                  <ResumeBox
                    key={`equipment_category_${name}`}
                    boxClassName={expandColumn ? 'col-span-full' : ''}
                    label={name}
                    value={count}
                  />
                );
              })}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default EquipmentCategorySummary;
